export default __webpack_public_path__ + "static/media/live6.14606906.jpeg";